module.exports = __webpack_public_path__ + "static/media/study 220602.3bfaeeeb.png";